import styled from 'styled-components';

export const SectionWrapper = styled.div`
  margin-left: 20px;
  padding: 30px 30px 0 5px;
  @media ${({ theme }) => theme.media.tablet} {
    padding-left: 40px;
  }
  @media ${({ theme }) => theme.media.laptop} {
    padding-left: 60px;
  }
`;
export const HeadlineOne = styled.h2`
  color: ${({ theme }) => theme.colors.headlineOne};
  font-size: ${({ theme }) => theme.fontSize.l};
  font-weight: 400;
  text-align: center;
  @media ${({ theme }) => theme.media.tablet} {
    font-size: ${({ theme }) => theme.fontSize.xl};
  }
`;

export const HeadlineTwo = styled.h3`
  font-size: ${({ theme }) => theme.fontSize.m};
  marin-top: 10px;
  font-weight: 400;
  text-align: center;

  @media ${({ theme }) => theme.media.tablet} {
    font-size: ${({ theme }) => theme.fontSize.l};
  }
`;

export const Paragraph = styled.p`
  color: ${({ theme }) => theme.colors.par};
  font-size: ${({ theme }) => theme.fontSize.m};
  font-weight: 200;
  /* text-align: center; */
  text-align: justify;
  @media ${({ theme }) => theme.media.tablet} {
    font-size: ${({ theme }) => theme.fontSize.l};
  }
  li {
    /* color: green; */
    /* color: #218921; */
    /* font-size: 25px; */
  }
`;

export const UnderHeader = styled.div`
  height: 80px;
  /* width: 100%; */
`;

export const WrapperCenter = styled.div`
  max-width: 120ch;
  margin: auto;
`;
